import React from "react";

function NavigationConfirmModal({ onCancel }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg p-6 min-w-[320px]">
        <div className="text-lg font-semibold mb-4 text-yellow-700">
          This document has not been saved. Save before leaving.
        </div>
        <div className="flex gap-4 justify-center mt-2">
          <button
            onClick={onCancel}
            className="bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg hover:bg-gray-200 transition"
          >
            Keep Editing
          </button>
        </div>
      </div>
    </div>
  );
}

export default NavigationConfirmModal;
